import { Box, Flex } from "@chakra-ui/react";
import time from "src/utils/time";
import environment from "src/utils/environment";
import getImageSrc from "src/utils/getImageSrc";
import TextField from "src/components/TextField";
import FileUploader from "../../FileUploader";
import Avatar from "../../Avatar";
import Select from "src/components/Select";

export default function Profile({
  onAvatarSelection,
  handleDateChange,
  onInputChange,
  croppedAvatar,
  avatar,
  t
}) {
  const { name, sex, birthDate, moreDataJson, objectId, breed } = avatar;

  const getBreedValue = () => {
    if (objectId == null) {
      return moreDataJson.breed;
    } else if (objectId) {
      if (
        (breed && !moreDataJson.breed) ||
        (breed === "" && !moreDataJson.breed)
      ) {
        return breed;
      } else if (moreDataJson) {
        return moreDataJson.breed;
      }
    }
  };

  return (
    <Box pt="16px">
      <Flex alignItems="flex-end" mb="24px" gap="8px" position="relative">
        <Avatar
          avatar={avatar}
          croppedAvatar={
            croppedAvatar ||
            getImageSrc("default-empty.svg", { directory: "dog-avatars" })
          }
          onClick={environment.isBrowser ? undefined : onAvatarSelection}
        />
        {environment.isBrowser && <FileUploader onChange={onAvatarSelection} />}
      </Flex>

      <Box mb="24px" maxWidth="280px">
        <TextField
          required={true}
          elevationLevel={1}
          label={t("avatar.editor.namePlaceholder")}
          name="name"
          value={name}
          type="text"
          onChange={onInputChange}
        />
      </Box>
      <Box mb="24px" maxWidth="280px">
        <TextField
          elevationLevel={1}
          label={t("avatar.breed")}
          value={getBreedValue()}
          name="breed"
          onChange={onInputChange}
        />
      </Box>
      <Flex
        alignItems="center"
        justifyContent="center"
        maxWidth="280px"
        gap="12px"
      >
        <Box width="50%">
          <Select
            elevationLevel={1}
            onChange={onInputChange}
            value={sex}
            label={t("sex")}
            name="sex"
          >
            <option value="female">{t("avatar.female")}</option>
            <option value="male">{t("avatar.male")}</option>
          </Select>
        </Box>
        <Box width="50%">
          <TextField
            type="date"
            label={t("birthDate")}
            elevationLevel={1}
            value={time(birthDate || new Date()).format("YYYY-MM-DD")}
            onChange={(e) => handleDateChange(e.target.value)}
            inputProps={{
              min: "1900-01-01",
              max: time(new Date()).format("YYYY-MM-DD")
            }}
          />
        </Box>
      </Flex>
    </Box>
  );
}
